import { HiOutlineMenu } from 'react-icons/hi';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import climactLogo from '../../../../assets/images/logo-climact.png';
import { toggleTopMenu } from '../../../../store/core/menuSlice';
import VersionSelect from '../../../UI/molecules/VersionSelect';
import MenuBurger from '../../molecules/MenuBurger';
import MenuTabs from '../../molecules/MenuTabs';
import headerStyle from './Header.module.css';

const url = {
  euClimate: 'https://europeanclimate.org/',
  be: 'https://www.belgium.be',
  planup: 'https://www.planup.eu/en/about',
  climactHome: 'https://www.climat.be/2050/fr-be/accueil/',
  climact: 'http://www.climact.com/',
};

const TEST_ENV = 'test';

const HeaderSimple = ({ sticky }) => {
  const dispatch = useDispatch();

  const handleMenuIconClick = () => {
    dispatch(toggleTopMenu());
  };

  return (
    <>
      <header className={`${headerStyle.header} ${sticky ? headerStyle.headerSticky : ''}`}>
        <nav className={headerStyle.nav}>
          <div className={headerStyle.navLeft}>
            <a href={url.climact} target='_blank' rel='noopener noreferrer' className={headerStyle.logo}>
              <img src={climactLogo} alt='Logo climact' />
            </a>
            <div className={headerStyle.titleVersionContainer}>
              <Link to='/dashboard' className={headerStyle.webtoolTitle}>
                2050 Pathways Explorer {window.env.REACT_APP_ENV === TEST_ENV && <span>TEST SERVER</span>}
              </Link>
              <VersionSelect />
            </div>
          </div>
          <MenuTabs />
        </nav>

        <button className={headerStyle.burgerMenuBtn} onClick={handleMenuIconClick}>
          <HiOutlineMenu size={25} color='var(--color-text)' />
        </button>
      </header>

      <MenuBurger />
    </>
  );
};

export default HeaderSimple;
